import { onValue, ref } from "firebase/database"
import { useEffect, useMemo, useState } from "react"
import { database } from "../../utils/firebase"
import "../../global.css"

interface TrackPoint {
  lat: number
  lng: number
  timestamp: number
}
interface TrackObject {
  coordinates: TrackPoint[]
  createdAt: number
  eventId: number
  id: number
  studentUID: number
  teacherUID: number
}
function calculateAverageSpeed(points): {
  averageSpeed: number
  totalDistanceKm: number
  timeMS: number
} {
  if (points.length < 2) {
    return { averageSpeed: 0, totalDistanceKm: 0, timeMS: 0 }
  }

  let totalDistanceKm = 0

  for (let i = 1; i < points.length; i++) {
    const prev = points[i - 1]
    const curr = points[i]
    totalDistanceKm += haversineDistance(prev, curr)
  }

  const timeHours =
    (points[points.length - 1].timestamp - points[0].timestamp) /
    (1000 * 60 * 60)
  const timeMS = points[points.length - 1].timestamp - points[0].timestamp

  return {
    averageSpeed: timeHours > 0 ? totalDistanceKm / timeHours : 0,
    totalDistanceKm,
    timeMS,
  }
}

// Haversine formula to calculate distance between two lat/lng points in km
function haversineDistance(p1, p2) {
  const R = 6371 // Earth's radius in km
  const toRad = (deg) => (deg * Math.PI) / 180

  const dLat = toRad(p2.lat - p1.lat)
  const dLng = toRad(p2.lng - p1.lng)

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(p1.lat)) * Math.cos(toRad(p2.lat)) * Math.sin(dLng / 2) ** 2

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}
let map: google.maps.Map

const Map = () => {
  const [speed, setSpeed] = useState(0)
  const [distance, setDistance] = useState(0)
  const [time, setTime] = useState(0)

  const tracksRef = useMemo(() => ref(database, "/tracks/7/1682"), [])
  useEffect(() => {
    async function initMap(): Promise<void> {
      const { Map } = (await google.maps.importLibrary(
        "maps",
      )) as google.maps.MapsLibrary

      map = new Map(document.getElementById("map") as HTMLElement, {
        center: { lat: 37.51797837, lng: -122.35239962 },
        zoom: 12,
      })
    }
    initMap()
    onValue(tracksRef, (snapshot) => {
      const data = snapshot.val() as Record<number, TrackObject>

      const coordinates = Object.values(data)[0].coordinates
      const points = Object.values(coordinates).map((coord) => ({
        lng: coord.lng,
        lat: coord.lat,
      }))

      const flightPath = new google.maps.Polyline({
        path: points,
        geodesic: true,
        strokeColor: "#3366ff",
        strokeOpacity: 1.0,
        strokeWeight: 4,
      })

      flightPath.setMap(map)

      map.setCenter(points[points.length - 1])
      const { averageSpeed, totalDistanceKm, timeMS } = calculateAverageSpeed(
        Object.values(coordinates),
      )

      setSpeed(averageSpeed)
      setDistance(totalDistanceKm)
      setTime(timeMS)
    })
  }, [tracksRef])

  return (
    <>
      <div id="map" style={{ width: "100%", height: "calc(100% - 100px)" }} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-evenly",
          height: 100,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 12 }}>מהירות ממוצעת:</div>
          <div>{Math.round(speed)} קמ״ש</div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 12 }}>אורך המסלול:</div>
          <div>{Math.round(distance)} ק״מ</div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 12 }}>זמן הנסיעה:</div>
          <div>{Math.round(time / 1000 / 60)} דקות</div>
        </div>
      </div>
    </>
  )
}
export default Map
